import AuthenticatedClient from './clients/AuthenticatedClient';

/**
 * Calls profiteia-backend /api/v2/me/access.
 *
 * The endpoint returns the user's resolved access set as composed by the
 * backend resolver (auth/access/resolver.py): the union of Stripe-derived
 * ProductFeature.entitlement_feature.lookup_keys with any active
 * EntitlementGrant rows, expanded against the canonical registry.
 *
 * Response shape:
 *   {
 *     allowed: string[],         // canonical entitlement keys
 *     denied: string[],          // explicit denies (override allows)
 *     is_super_user: boolean,
 *     unknown_keys: string[],    // claim strings the backend didn't recognise
 *     version: string            // 12-char hash; changes when grants change
 *   }
 */
export default {
  fetchAccess() {
    // `AuthenticatedClient`'s baseURL already includes the `/api/v2` prefix, so
    // this path is relative — passing `/api/v2/me/access` here double-prefixes
    // it to `/api/v2/api/v2/me/access`, which 404s and leaves the resolved
    // access set unhydrated. Keep this consistent with the other repositories.
    return AuthenticatedClient.get('/me/access');
  },
};
